import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceTabs = ({ services, activeService, onServiceChange }) => {
  return (
    <div className="bg-card rounded-xl shadow-sm p-2 overflow-x-auto">
      <div className="flex gap-2 min-w-max">
        {services?.map((service) => (
          <button
            key={service?.id}
            onClick={() => onServiceChange(service?.id)}
            className={`flex items-center gap-2 px-4 py-3 rounded-lg font-medium transition-all duration-200 flex-shrink-0 ${
              activeService === service?.id
                ? 'bg-primary text-primary-foreground shadow-md'
                : 'text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={service?.icon} size={18} />
            <span className="text-sm md:text-base whitespace-nowrap">{service?.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ServiceTabs;